import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import HeaderOne from '../Components/Header/HeaderOne';
import Blogs from '../Blog/Home';
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";

function BlogDetails() {
  const { id } = useParams();

  const staticBlog = Blogs.find((b) => b.id === id);
  const [dbBlog, setDbBlog] = useState(null);
  const [loading, setLoading] = useState(!staticBlog);

  useEffect(() => {
    if (staticBlog) return;
    setLoading(true);
    const apiUrl = window.location.port === '3000' 
      ? `/tt-react/public/blog-posts.php?slug=${encodeURIComponent(id)}` 
      : `/blog-posts.php?slug=${encodeURIComponent(id)}`;
    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setDbBlog({
            id: data.data.slug,
            title: data.data.title,
            seoTitle: data.data.seo_title,
            seoDescription: data.data.seo_description,
            seoKeywords: data.data.seo_keywords,
            ogTitle: data.data.og_title,
            ogDescription: data.data.og_description,
            image: data.data.image,
            content: <div dangerouslySetInnerHTML={{ __html: data.data.content }} />,
          });
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const blog = staticBlog || dbBlog;

  if (loading) return null;
  if (!blog) return <h2>Blog Not Found</h2>;

  return (
    <>
      <Helmet>
        <title>{blog.seoTitle || blog.title}</title>
        <meta name="description" content={blog.seoDescription || "Read this amazing blog post from Tickling Tummy about homemade vegetarian food in Coimbatore."} />
        <meta name="keywords" content={blog.seoKeywords || "Tickling Tummy blog, homemade food Coimbatore, vegetarian cooking"} />
        <link rel="canonical" href={`https://ticklingtummy.com/${blog.id}`} />

        {/* Open Graph Tags */}
        <meta property="og:title" content={blog.ogTitle || blog.seoTitle || blog.title} />
        <meta property="og:description" content={blog.ogDescription || blog.seoDescription || "Read this amazing blog post from Tickling Tummy about homemade vegetarian food in Coimbatore."} />
        <meta property="og:image" content={blog.image ? `https://ticklingtummy.com/${blog.image}` : "https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg"} />
        <meta property="og:url" content={`https://ticklingtummy.com/${blog.id}`} />
        <meta property="og:type" content="article" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.ogTitle || blog.seoTitle || blog.title} />
        <meta name="twitter:description" content={blog.ogDescription || blog.seoDescription || "Read this amazing blog post from Tickling Tummy about homemade vegetarian food in Coimbatore."} />
        <meta name="twitter:image" content={blog.image ? `https://ticklingtummy.com/${blog.image}` : "https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg"} />
      </Helmet>
      <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://ticklingtummy.com"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Blog",
            "item": "https://ticklingtummy.com/blogs"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": blog.title,
            "item": `https://ticklingtummy.com/${blog.id}`
          }
        ]
      }, null, 2)}
      </script>

      <HeaderOne />

      {dbBlog && (
        <section className="inner-banner">
          <div
            className="image-layer"
            style={{ backgroundImage: 'url("/assets/images/coimbatore-homemade-food-banner.jpg")' }}
          ></div>
          <div className="auto-container">
            <div className="inner">
              <h1>{blog.title}</h1>
              <div className="sub_text">
                <p>
                  Home - <Link to="/blogs" className="primary-color">Blogs</Link>
                </p>
              </div>
            </div>
          </div>
        </section>
      )}

      <div className="blog-container">
        {dbBlog ? (
          <section className="blog_detail_section section-kt">
            <div className="auto-container">
              <div className="blog_inner_pannel">
                <div className="blog_info info">
                  {blog.content}
                </div>
              </div>
            </div>
          </section>
        ) : (
          blog.content
        )}
      </div>

      <Footer />
    </>
  );
}

export default BlogDetails;
